import L from "leaflet"

const ICON_SIZE = 32

export const barIcon_1 = L.icon({
  iconUrl: "/images/bar1.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})

export const barIcon_2 = L.icon({
  iconUrl: "/images/bar2.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})

export const barIcon_25 = L.icon({
  iconUrl: "/images/bar25.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})

export const barIcon_3 = L.icon({
  iconUrl: "/images/bar3.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})
export const barIcon_4 = L.icon({
  iconUrl: "/images/bar4.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})

export const barIcon_5 = L.icon({
  iconUrl: "/images/bar5.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})

export const barIcon_6 = L.icon({
  iconUrl: "/images/bar6.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})

export const barIcon_7 = L.icon({
  iconUrl: "/images/bar7.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})

export const barIcon_star = L.icon({
  iconUrl: "/images/extra.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})

export const deniedIcon = L.icon({
  iconUrl: "/images/denied.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})

export const serviceIcon = L.icon({
  iconUrl: "/images/service.png",
  iconSize: [ICON_SIZE, ICON_SIZE],
})
